import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../hooks'
import { FormModalContainer, useCloseConfirm } from '../../Form'
import { useResizeModal } from '../../Modal'
import { DocFlowForm } from '../DocFlowForm'

import { QA_NAME_DOC_FLOW_CREATION_MODAL } from './DocFlowFormModal.constants'

function DocFlowFormModal({
  fieldProps,
  title = 'Modal.NewDocumentStaplingTitleKey',
  onClose,
  ...restProps
}) {
  const { t } = useTranslation()

  const [modal, setModal] = useState(null)

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const { fullScreen, handleResizeModal } = useResizeModal()

  return (
    <DocFlowForm
      {...restProps}
      FormContainer={FormModalContainer}
      containerProps={{
        isCloseConfirm,
        isFullScreen: isMobileScreenSize || fullScreen,
        modal,
        qaName: QA_NAME_DOC_FLOW_CREATION_MODAL,
        setCloseConfirm,
        title: t(title),
        onClose,
        onResize: isMobileScreenSize ? null : handleResizeModal,
      }}
      fieldsProps={{
        ...fieldProps,
        contentComponentProps: {
          ...fieldProps?.contentComponentProps,
          isFullScreen: isMobileScreenSize || fullScreen,
        },
      }}
      setModal={setModal}
      onCancel={handleClose}
    />
  )
}

export default DocFlowFormModal
